import React, { Fragment,useContext } from 'react'
import {AppSearchAdvancedItemProps} from './index'
import {AppTableSearchContext,AppFilter,SearchEnum} from 'qcc'
import {AppTextSearch} from './AppTextSearch'
import {AppMultCheck} from './AppMultCheck'
import {AppNumberRange} from './AppNumberRange'
import {AppDateRange} from './AppDateRange'
import './index.less'
import { appNumber } from 'utils';

export const AppSearchAdvancedItem = (props:AppSearchAdvancedItemProps) =>{

    const {onItemChange,filterList} = useContext(AppTableSearchContext)

    let itemType = props.itemType || SearchEnum.itemType.text
    let keyName = props.keyName || '';
    let filter = filterList.find(f => f.keyName===keyName)|| {lable:props.lable||'', keyName,min:'',max:'',list:[],value:'', opr:props.opr || SearchEnum.opr.Or,allowClear:true,field:props.field || ''};

    const handleMulitCheckChange = (valueList?:string[]) =>{
        let appFilter:AppFilter = {...filter,
            list:valueList || [],
            searchItemType:SearchEnum.itemType.multCheck,
            opr:SearchEnum.opr.In
		}
		onItemChange(appFilter)
    }

    const handleNumberRange = (minNumber?:number,maxNumber?:number) =>{
        let min = minNumber ? minNumber.toString() : '';
        let max = maxNumber ? maxNumber.toString() :'' ;
        let appFilter:AppFilter = {...filter,min,max,
            searchItemType:SearchEnum.itemType.numberRange,
            opr:SearchEnum.opr.Between
        };
        onItemChange(appFilter)
    }

    const handleDateRange = (min?:string,max?:string) =>{
        let appFilter = {...filter,min,max,
            searchItemType:SearchEnum.itemType.numberRange,
            opr:SearchEnum.opr.Between
        };
        onItemChange(appFilter)
    }

    const handleDefault =(value?:string) =>{
        let appFilter = {...filter,value,
            searchItemType:SearchEnum.itemType.text,
            opr:SearchEnum.opr.Like
        };
        onItemChange(appFilter)
    }

    const renderItem = () =>{
        let key = '_app_key_';
        switch (itemType){
            case SearchEnum.itemType.multCheck:
                if(Array.isArray(filter.list)){
                    key= `_app_key_${filter.list.join('_')}`
                }
                return <AppMultCheck 
                            options={props.options} 
                            key = {key}
                            value={filter.list} 
                            onChange={handleMulitCheckChange}
                        />
            case SearchEnum.itemType.numberRange:
                key= `_app_key_${filter.min}_${filter.max}`
                return <AppNumberRange 
                            key ={key}
                            format={props.format} 
                            min={appNumber.toNumber(filter.min)} 
                            max={appNumber.toNumber(filter.max)}
                            onChange = {handleNumberRange}
                        />
            case SearchEnum.itemType.dateRange:
                key= `_app_key_${filter.min}_${filter.max}`
                return <AppDateRange 
                            format = {props.format}
                            min = {filter.min}
                            max = {filter.max}
                            onChange ={handleDateRange}
                            key={key}
                        />
            default:
                key = `_app_key_${filter.value}`
                return <AppTextSearch 
                            key={key} 
                            value={filter.value} 
                            onChange={handleDefault}
                        />
        } 
    }
    return renderItem();
}


// WEBPACK FOOTER //
// ./src/qcc/AppSearchItem/AppSearchAdvancedItem.tsx